import { render, staticRenderFns } from "./AgendaLeiloes.vue?vue&type=template&id=3a23a8de&"
import script from "./AgendaLeiloes.vue?vue&type=script&lang=js&"
export * from "./AgendaLeiloes.vue?vue&type=script&lang=js&"
import style0 from "./AgendaLeiloes.vue?vue&type=style&index=0&id=3a23a8de&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports